import { atom } from "recoil"

export const matchingSubGroupState = atom<boolean>({
  key: "atoms/sidebar/matchingSubGroupState",
  default: false,
})
